import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';

export const CustomSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CustomSelectLabel = styled.label`
  font-size: 0.875rem;
  color: ${colors.GRAY_DARK};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;
